import { useControls } from 'leva';
import { useState, useCallback } from 'react';
import PianoCucina from './PianoCucina';
import ModuloPanel from './ModuloPanel';

export default function EsempioProcedurale() {
  const { numModuli } = useControls('Configurazione', {
    numModuli: { value: 3, min: 1, max: 8, step: 1, label: 'Numero moduli' },
  });

  const [moduliValues, setModuliValues] = useState({});

  const handleChange = useCallback((index, values) => {
    setModuliValues(prev => ({ ...prev, [index]: values }));
  }, []);

  const moduli = Array.from({ length: numModuli }, (_, i) => {
    const v = moduliValues[i + 1] || {};
    return {
      id: i + 1,
      larghezza: v.larghezza ?? 60,
      foro: v.ha_foro ? {
        larghezza: v.foro_larghezza ?? 40,
        profondita: v.foro_profondita ?? 40,
        radius: v.foro_radius ?? 5,
      } : undefined,
    };
  });

  return (
    <>
      {Array.from({ length: numModuli }, (_, i) => (
        <ModuloPanel key={i + 1} index={i + 1} onChange={handleChange} />
      ))}
      <PianoCucina moduli={moduli} />
    </>
  );
}
